<template lang="pug">
v-flex 
  v-card
    v-card-title Trabajadores
      v-spacer
      v-text-field(v-model='search' append-icon='fa-search' label='Buscar ' single-line hide-details)
      v-dialog(v-model='Trabajadores.dialog' max-width='500px')
        template(v-slot:activator='{ on }')
          v-btn.mb-2(color='primary' dark v-on='on' @click='clearForm()') Añadir
        v-card
          v-card-title
            span.headline {{ title }}
          v-card-text
            v-container(grid-list-md)
              v-layout(wrap)
                v-flex(xs12 sm6)
                  v-text-field(v-model='data.nombre' label='Nombre')
                v-flex(xs12 sm6)
                  v-text-field(v-model='data.documento' label='Documento')
                v-flex(xs12 sm6)
                  v-text-field(v-model='data.telefono' label='Teléfono')
                v-flex(xs12 sm6)
                  v-text-field(v-model='data.email' label='E-mail') 
                v-flex(xs12 sm6)
                  v-text-field(v-model='data.direccion' label='Dirección')
          v-card-actions
            v-spacer
            v-btn(color='primary' @click='save()') {{ titleButton }}
    v-data-table.elevation-1(:headers='headers' :items='Trabajadores_registro' :search='search')
      template(v-slot:item.action='{item}')
        v-btn(color='secondary' icon @click='editItem(item.key)')
            v-icon(small) far fa-edit
        v-btn(color='secondary' icon @click='deleteItem(item.key)')
            v-icon(small) far fa-trash-alt
</template>
<script>
import {mapActions, mapGetters, mapState, mapMutations} from 'vuex'
export default {
  data: () => ({
    search: '',
    headers: [
      {
        text: 'Lista de Trabajadores',
        align: 'left',
        value: 'nombre'},
      { text: 'Documento', value: 'documento' },
      { text: 'Teléfono', value: 'telefono' },
      { text: 'E-mail', value: 'email' },
      { text: 'Dirección', value: 'direccion' },
      { text: 'Fecha', value: 'createdAt' },
      { text: '', value: 'action', sortable: false }
    ],
    record: [],
  }),
    methods: {
      ...mapActions({
        editItem: 'Trabajadores/get',
        deleteItem: 'Trabajadores/clean',
        save: 'Trabajadores/add',
        clearForm: 'Trabajadores/clearForm',
      }),
    },
    computed: {
      title() { return this.Trabajadores.selectedKey == '' ? 'Registar' : 'Crear' },
      titleButton() { return this.Trabajadores.selectedKey == "" ? 'Guardar' : 'Editar' },
      ...mapGetters({
        Trabajadores_registro: 'Trabajadores/registro',
      }),
       ...mapState({
      data: state=> state.Trabajadores.datos,
      Trabajadores :state=> state.Trabajadores,
      rules: state=>state.Helpers.rules
    })
  }
}
</script>
